var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VisualizarSolicitacao.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b754e7cc\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VisualizarSolicitacao.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/solicitacao-de-subsidio/VisualizarSolicitacao.vue
// module id = 1085
// module chunks = 1